import { render, staticRenderFns } from "./GatewayControlCabinet1V1ControllerTelemetryCard.vue?vue&type=template&id=486e39a8&scoped=true&"
import script from "./GatewayControlCabinet1V1ControllerTelemetryCard.vue?vue&type=script&lang=ts&"
export * from "./GatewayControlCabinet1V1ControllerTelemetryCard.vue?vue&type=script&lang=ts&"
import style0 from "./GatewayControlCabinet1V1ControllerTelemetryCard.vue?vue&type=style&index=0&id=486e39a8&scoped=true&lang=scss&"
import style1 from "./GatewayControlCabinet1V1ControllerTelemetryCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486e39a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
